import { render, staticRenderFns } from "./DocumentBody.vue?vue&type=template&id=9c230f68&"
import script from "./DocumentBody.vue?vue&type=script&lang=js&"
export * from "./DocumentBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports